module.exports = __webpack_public_path__ + "img/Mensingles.98882302.png";